export default __webpack_public_path__ + "static/media/SR_Ramiel.4afdd660.png";